const addressToUniqueName = address => address.match(/[A-Za-z0-9]+/g).join("");

export default addressToUniqueName;
